<template>
	<transition name="fade">
		<div class="col-sm-6 col-lg-4" v-if="car_remain_time_in_ms > 0 && is_show == 1">
			<div :class="`card cardv1 ${card_glow}`">
				<router-link :to="{name:'car', params:{slug: product.slug}}"  class="card-link">
					<span class="lable" v-if="product.is_checked_file">
						<img src="../../@core/pic/checkfile.svg" alt="">
					</span>
					<div class="img-wr" :class="(car_availablity == 'coming_soon')? ' coming-soon-overlay-p':''">
						<img v-lazy="product.image" alt="">
						<div v-if="car_availablity == 'coming_soon'" class="coming-soon-overlay" >
							{{ $t('gen.start_soon') }}
						</div>
						<span v-if="product.city != ''" style=" position: absolute; bottom: 0; left: 0; display: block; background: #6360aa; z-index: 9; color: #fff; padding: 4px 15px; ">
							{{ product.city }}
						</span>
					</div>
				</router-link>
				<div class="center">
					<div class="card-title">
						<div class="name">{{product.title}}</div>
						<span class="i-wr" v-if="IsAuth">
							<button @click="favourite" v-if="fav" style="color:#33ad70" class="btn">
								<i class="fas fa-star" style="font-size: 1.2rem;"></i>
							</button>
							<button @click="favourite" v-if="!fav" class="btn">
								<i class="far fa-star" style="font-size: 1.2rem;"></i>
							</button>
						</span>
						<span class="i-wr" v-if="!IsAuth">
							<button type="button"  data-toggle="modal" data-target="#loginmo"  class="btn">
								<i class="far fa-star" style="font-size: 1.2rem;"></i>
							</button>
						</span>
					</div>
					<!-- show in grid only start -->
					<div class="bar">
						<div class="last-price item">
							<img src="../../@core/pic/dollar.png" alt="">
							<div class="text" v-if="product.without_bidding == 1">
								<div class="lbl">{{ $t('gen.purchase_price') }}</div>
								<div :class="'val cur-product-'+product.id">{{product.purchase_price}} {{ $t('gen.currency') }}</div>
							</div>
							<div class="text" v-else>
								<div class="lbl">{{ $t('auction.current_price') }}</div>
								<div :class="'val cur-product-'+product.id">{{product.auction_current_price}} {{ $t('gen.currency') }}</div>
							</div>
						</div>
						<div class="bid item">
							<img src="../../@core/pic/bid.png" alt="">
							<div class="text" v-if="product.without_bidding == 1 && product.discount != ''">
								<div class="lbl">{{ $t('gen.discount') }}</div>
								<!-- <div class="val" :id="'pproduct-'+product.id">{{product.auction_min_price}} {{ $t('gen.currency') }}</div> -->
								<div class="val" >{{product.discount_amount}} {{ $t('gen.currency') }}</div>
							</div>
							<div class="text" v-else-if="product.without_bidding == 1 ">
								<!-- <div class="lbl">{{ $t('gen.min_bid') }}</div> -->
								<!-- <div class="val" :id="'pproduct-'+product.id">{{product.auction_min_price}} {{ $t('gen.currency') }}</div> -->
								<!-- <div class="val" >{{product.auction_min_price}} {{ $t('gen.currency') }}</div> -->
							</div>
							<div class="text" v-else>
								<div class="lbl">{{ $t('gen.min_bid') }}</div>
								<!-- <div class="val" :id="'pproduct-'+product.id">{{product.auction_min_price}} {{ $t('gen.currency') }}</div> -->
								<div class="val" >{{product.auction_min_price}} {{ $t('gen.currency') }}</div>
							</div>
						</div>
					</div>
					<!-- show in grid only end -->
					<table class="table  no-outer">
						<tbody>
							<tr>
								<td v-if="product.without_bidding != 1">
									<div class="lbl">{{ $t('auction.bid_count') }}</div>
									<div :class="'val pro-bids-count-'+product.id">{{product.auction_count}}</div>
								</td>
								<td v-if="product.without_bidding == 1 && product.discount != ''">
									<div class="lbl">{{ $t('gen.discount') }}</div>
									<div :class="'val pro-bids-count-'+product.id">{{product.discount}}</div>
								</td>
								<td>
									<div class="lbl">{{ $t('car.model') }}</div>
									<div class="val">{{product.model}} {{product.year}}</div>
								</td>
								<td>
									<div class="lbl">{{ $t('auction.serial') }}</div>
									<div class="val">{{product.id}}</div>
								</td>
							</tr>
							<tr>
								<td>
									<div class="lbl" v-if="car_availablity == 'coming_soon'">{{ $t('gen.auc_start_after') }} </div>
									<div class="lbl" v-else>{{ $t('auction.remaining_time') }}</div>
									<countdown-timer v-if="car_availablity == 'coming_soon'" :timeInMillis="product.car_availablity_sm" @timer-end="ComingSoonEnd" />
									
									<countdown-timer v-else :timeInMillis="car_remain_time_in_ms" @timer-end="TimerEnds" @timer-end-soon="EndsSoon" @timer-progress="TimerProgress" />
									
									<label class="hghh" @click="timerFN" style="display: none;"></label>
								</td>
								<td>
									<div class="lbl">{{ $t('car.kilometers') }}</div>
									<div class="val">{{product.distance}}</div>
								</td>
								<td>
									<div class="lbl">{{ $t('car.condition') }}</div>
									<div class="val">{{product.condition}}</div>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="btn-wr">
					<!-- hide on grid start -->
					<div class="last-price item">
						<div class="text" v-if="product.without_bidding == 1">
							<div class="lbl">{{ $t('gen.purchase_price') }}</div>
							<div :class="'val cur-product-'+product.id">{{product.purchase_price}} {{ $t('gen.currency') }}</div>
						</div>
						<div class="text" v-else>
							<div class="lbl">{{ $t('auction.current_price') }}</div>
							<div :class="'val cur-product-'+product.id">{{product.auction_current_price}} {{ $t('gen.currency') }}</div>
						</div>
					</div>
					<div class="bid item">
						<div class="text" v-if="product.without_bidding == 1 && product.discount != ''">
								<div class="lbl">{{ $t('gen.discount') }}</div>
								<!-- <div class="val" :id="'pproduct-'+product.id">{{product.auction_min_price}} {{ $t('gen.currency') }}</div> -->
								<div class="val" >{{product.discount_amount}} {{ $t('gen.currency') }}</div>
							</div>
							<div class="text" v-else-if="product.without_bidding == 1 ">
								<!-- <div class="lbl">{{ $t('gen.min_bid') }}</div> -->
								<!-- <div class="val" :id="'pproduct-'+product.id">{{product.auction_min_price}} {{ $t('gen.currency') }}</div> -->
								<!-- <div class="val" >{{product.auction_min_price}} {{ $t('gen.currency') }}</div> -->
							</div>
							<div class="text" v-else>
								<div class="lbl">{{ $t('gen.min_bid') }}</div>
								<!-- <div class="val" :id="'pproduct-'+product.id">{{product.auction_min_price}} {{ $t('gen.currency') }}</div> -->
								<div class="val" >{{product.auction_min_price}} {{ $t('gen.currency') }}</div>
							</div>
					</div>
					<!-- hide on grid end -->
					<router-link v-if="car_remain_time_in_ms > 0 && product.auction_id == null && is_show == 1" :to="{name:'car', params:{slug: product.slug}}" class="btn btn-block btn-success btn-su-rev">
						{{ $t('auction.view_details') }}
					</router-link>
					<router-link v-if="car_remain_time_in_ms > 0 && product.auction_id != null && is_show == 1" :to="{name:'auction', params:{slug: product.auction_slug}}" class="btn btn-block btn-success btn-su-rev">
						{{ $t('auction.view_details') }}
					</router-link>
				</div>
			</div>
		</div>
	</transition>
							<!-- card-col end -->
</template>

<script>
import { nextTick, ref } from 'vue';
const renderComponent = ref(true);

import { mapGetters, mapActions ,mapMutations} from "vuex";

import CountdownTimer from '../helpers/CountdownTimer.vue';
import store from '@/store'
export default {
    components: {
      CountdownTimer
    },
	props:{
		product :{
			require: true
		}
	},
	data() {
		return {
			car_availablity: this.product.car_availablity,
			car_normal_date: this.product.normal_date,
			renderComponent: true,
			fav: this.product.is_fav,
			car_remain_time_in_ms: this.product.remain_time_in_ms,
			is_show: 1,
			card_glow: '',
			timer_color_c: 'move-color',
			IsAuth: false,
			timer: {
				day: null,
				hour: null,
				minute: null,
				second: null,
			}
		}
	},
	
	watch: {
		"$store.state.home.current_server_time":{
			handler(val){
				if(val != 0){

					let expiration_time = new Date(this.car_normal_date).getTime();
					let server_time = new Date(val).getTime();
					// console.log("diff", expiration_time, server_time, val);
					let diff_time = expiration_time - server_time;
					if(diff_time <= 1000){
						this.is_show = 0;
					}else{
						this.car_remain_time_in_ms = diff_time;
					}
				}
			},
			deep:true
		}
	},
	methods: {
		favourite(){
		this.$http.post('/toggle-favourite',{product_id: this.product.id}).then(response => {
			
			this.fav = response.data.data.fav;

				}).catch(err => {
				console.log({err:err})
				})
      },
		timerFN(){
			// if(this.timer.second != null && (this.timer.day + this.timer.hour + this.timer.minute + this.timer.second) == 0){
			// 	// console.log("this.is_show = 0;",this.timer.day , this.timer.hour , this.timer.minute , this.timer.second)
      		// 	this.is_show = 0;
			// }
      },
	  
	  TimerEnds() {
		this.is_show = 0;
      },
	  EndsSoon() {
		this.card_glow = 'glow-card'; 
      },
	  TimerProgress() {
		if (this.car_remain_time_in_ms == 180000 /*300000*/){
			this.car_remain_time_in_ms = 180000 /*300000*/ - 1;
		  }
      },
	  ComingSoonEnd() {
		this.car_availablity = "available";
      },
	  
	  async forceRerender() {
      // Remove MyComponent from the DOM
      this.renderComponent = false;

            // Wait for the change to get flushed to the DOM
      await this.$nextTick();

      // Add the component back in
      this.renderComponent = true;
    }
	},
	mounted() {
                window.Echo.channel(`product-bid-add-five-` + this.product.id)
		.listen('ProductBidAddFiveEvent', (e) => {
			// console.log("this.timer.minute", this.timer.minute);
            this.car_normal_date = e.data.normal_date;
			// this.$toast.open({
            //             message: 'reset time To 5 Minutes',
            //             type: 'success',
            //             // all of other options may go here
            //         });
			this.car_remain_time_in_ms = 180000 /*300000*/;

                });
		let token = window.localStorage.getItem('authToken') || null;
		if (token != null) {
			this.IsAuth=true;
		}
		// document.body.onfocus = function(e){
		// 	// document.getElementById('hghh').click();
		// 	console.info("dd", e.type)
		// 	let lst = document.getElementsByClassName('hghh')
		// 	for (let i = 0; i < lst.length; i++) {
		// 		lst.item(i).click();
		// 	}
		// }
	}
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity 4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>